<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider
        :ref="name"
        :name="name"
        :vid="name"
        :rules="rules"
        mode="eager"
        v-slot="{ errors }"
      >
        <v-text-field
          :label="label"
          v-model="formattedDate"
          :error-messages="errors[0]"
          v-bind="{...input}"
          :style="customStyle"
          readonly
          v-on="on"
        />
      </ValidationProvider>
    </template>
    <v-date-picker
      :ref="name"
      v-model="date"
      :locale="$root.$i18n.locale.toLowerCase()"
      :active-picker="activePicker"
      :max="max"
      v-bind="{...picker}"
      first-day-of-week="1"
    />
  </v-menu>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import {getFieldRules, getMaxDateField} from '@/utils/auth/validation'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      menu: false,
      date: '',
      activePicker: ''
    }
  },
  computed: {
    format() {
      return _.get(this.component, 'format', 'DD.MM.YYYY')
    },
    formattedDate() {
      return this.date ? moment(this.date).format(this.format) : ''
    },
    name() {
      return _.get(this.component, 'name', '')
    },
    label() {
      return _.get(this.component, 'label', '')
    },
    max() {
      return getMaxDateField(this.component)
    },
    rules() {
      return getFieldRules(this.component)
    },
    // https://vuetifyjs.com/en/api/v-date-picker/
    picker() {
      return _.get(this.component, 'props.picker', {})
    },
    // https://vuetifyjs.com/en/api/v-text-field/
    input() {
      return _.get(this.component, 'props.input', {})
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    }
  },
  watch: {
    date() {
      this.$emit('input', this.formattedDate)
    },
    menu(value) {
      value && this.$nextTick(() => this.activePicker = 'YEAR')
    }
  },
  created() {
    this.$emit('field-registered', this.name)

    if (this.value) {
      this.date = moment(this.value, 'DD.MM.YYYY').format('YYYY-MM-DD')
    }
  },
}
</script>

<style lang="scss" scoped></style>
